import { render, staticRenderFns } from "./ManagePersonModal.vue?vue&type=template&id=c1b0ab36&scoped=true&"
import script from "./ManagePersonModal.vue?vue&type=script&lang=js&"
export * from "./ManagePersonModal.vue?vue&type=script&lang=js&"
import style0 from "./ManagePersonModal.vue?vue&type=style&index=0&id=c1b0ab36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b0ab36",
  null
  
)

export default component.exports